<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.py_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="py_kind">
            <label class="weui-form-preview__label">{{
              customLabel.py_kind || "计划类别"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.py_kind
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="py_year" v-if="form.main.py_kind == '年计划'">
            <label class="weui-form-preview__label">{{
              customLabel.py_year || "年份"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.py_year
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="py_yearmonth" v-if="form.main.py_kind == '月计划'">
            <label class="weui-form-preview__label">{{
              customLabel.py_yearmonth || "期间"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.py_yearmonth
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="py_type">
            <label class="weui-form-preview__label">{{
              customLabel.py_type || "类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.py_type
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="py_emname">
            <label class="weui-form-preview__label">{{
              customLabel.py_emname || "人员名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.py_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="py_dpname">
            <label class="weui-form-preview__label">{{
              customLabel.py_dpname || "部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.py_dpname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="py_growthrate">
            <label class="weui-form-preview__label">{{
              customLabel.py_growthrate || "实际增长率"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.py_growthrate
            }}%</span>
          </div>
          <div class="weui-form-preview__item" slot="py_remark">
            <label class="weui-form-preview__label">{{
              customLabel.py_remark || "备注"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.py_remark
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.pyd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pyd_custname" v-if="form.main.py_type == '按客户'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_custname || "客户名称"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_custname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_prodcode" v-if="form.main.py_type == '按客户'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_prodcode || "产品编号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_prodcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_detail" v-if="form.main.py_type == '按客户'">
              <label class="weui-form-preview__label">{{
                customLabel.pr_detail || "产品名称"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pr_detail }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_spec" v-if="form.main.py_type == '按客户'">
              <label class="weui-form-preview__label">{{
                customLabel.pr_spec || "规格"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pr_spec }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_orispeccode" v-if="form.main.py_type == '按客户'">
              <label class="weui-form-preview__label">{{
                customLabel.pr_orispeccode || "型号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pr_orispeccode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_brand" v-if="form.main.py_type == '按品牌'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_brand || "品牌"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pyd_brand }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_total" v-if="form.main.py_kind == '年计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_total || "年度计划目标"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pyd_total }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_pretotal" v-if="form.main.py_kind == '年计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_pretotal || "上年度金额"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_pretotal
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_thistotal" v-if="form.main.py_kind == '月计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_thistotal || "本月计划目标"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_thistotal
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_amount1" v-if="form.main.py_kind == '年计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_amount1 || "1月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_amount1
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_amount2" v-if="form.main.py_kind == '年计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_amount2 || "2月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_amount2
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_amount3" v-if="form.main.py_kind == '年计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_amount3 || "3月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_amount3
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_amount4" v-if="form.main.py_kind == '年计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_amount4 || "4月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_amount4
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_amount5" v-if="form.main.py_kind == '年计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_amount5 || "5月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_amount5
              }}</span>
            </div>

            <div class="weui-form-preview__item" slot="pyd_amount6" v-if="form.main.py_kind == '年计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_amount6 || "6月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_amount6
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_amount7" v-if="form.main.py_kind == '年计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_amount7 || "7月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_amount7
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_amount8" v-if="form.main.py_kind == '年计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_amount8 || "8月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_amount8
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_amount9" v-if="form.main.py_kind == '年计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_amount9 || "9月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_amount9
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_amount10" v-if="form.main.py_kind == '年计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_amount10 || "10月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_amount10
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_amount11" v-if="form.main.py_kind == '年计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_amount11 || "11月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_amount11
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_amount12" v-if="form.main.py_kind == '年计划'">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_amount12 || "12月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_amount12
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pyd_remark">
              <label class="weui-form-preview__label">{{
                customLabel.pyd_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pyd_remark
              }}</span>
            </div>
          </custom-layout>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <!-- <router-link
        :to="'/sale/planyear_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      > -->
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <!-- <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      > -->
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";


export default {
  mixins: [process],
  components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/sale/planyear",
      codeField: "py_code",
      statusField: "py_statuscode",
      caller: "PlanYear",
      xtype: "sale-planyear-formpanel",
    };
  },
};
</script>